import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#667085",
      d: "M10 9.99c0 .647.688 1.052 1.24.731l3.142-1.823a.848.848 0 0 0 0-1.462L11.24 5.612c-.552-.32-1.24.085-1.24.731z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#667085",
      "fill-rule": "evenodd",
      d: "M.5 4.833C.5 4.373.873 4 1.333 4c1.271 0 2.215.228 2.98.608.754.374 1.282.871 1.72 1.289l.018.017c.444.422.787.75 1.251.996.45.239 1.063.423 2.031.423h.826a.833.833 0 1 1 0 1.667h-.826c-.968 0-1.58.184-2.03.424-.465.246-.808.573-1.252.995l-.018.018c-.438.417-.966.915-1.72 1.289-.765.38-1.709.607-2.98.607a.833.833 0 1 1 0-1.666c1.063 0 1.744-.189 2.24-.434.505-.251.874-.587 1.31-1.003l.066-.062c.331-.317.716-.684 1.206-1.001-.49-.318-.875-.685-1.206-1.001l-.065-.063c-.437-.416-.806-.751-1.312-1.002-.495-.246-1.176-.434-2.239-.434A.833.833 0 0 1 .5 4.833",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }